'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isIpfs = require('is-ipfs');
var toCidAndPath = require('ipfs-core-utils/to-cid-and-path');
var drain = require('it-drain');
var utils = require('../../utils.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var isIpfs__default = /*#__PURE__*/_interopDefaultLegacy(isIpfs);
var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

async function resolvePath({ipns, repo, codecs}, name, options) {
  if (isIpfs__default["default"].ipnsPath(name)) {
    return ipns.resolve(name);
  }
  const {cid, path} = toCidAndPath.toCidAndPath(name);
  await drain__default["default"](utils.resolve(cid, path || '', codecs, repo, options));
}

exports.resolvePath = resolvePath;
